export default {
  methods: {
    successNotify(message) {
      this.$notify({
        title: '成功',
        message,
        type: 'success',
        duration: 2000
      })
    },
    errorNotify(message) {
      this.$notify({
        title: '失败',
        message,
        type: 'error',
        duration: 2000
      })
    }
  }
}
